/**
 * Created by quikr on 11/8/16.
 */
/**
 * Created by quikr on 8/26/16.
 */
import React, {Component} from "react";
import {reduxForm} from "redux-form";
import Button from "react-bootstrap/lib/Button";
import Checkbox from "material-ui/Checkbox";
import DatePicker from "material-ui/DatePicker";
import * as actions from "../../redux/actions/leaveActions";


let min = new Date();
min.setDate(min.getDate() - 2);
let max = new Date();
max.setDate(max.getDate() - 1);

let from = new Date();
from.setDate(from.getDate() - 1);
let to = new Date();
to.setDate(to.getDate() + 5);
min = to;
var default_search = {
  startDate: from,
  endDate: to
};
let d1 = new Date();
let z = d1.getDay() - 1;
if (z >= 0)
  d1.setDate(d1.getDate() - z);
else
  d1.setDate(d1.getDate() - 6);

let d2 = d1;
d2.setDate(d2.getDate() + 4);
let d3 = new Date();
let z1 = d3.getDay() - 1;
if (z >= 0)
  d3.setDate(d3.getDate() - z1);
else
  d3.setDate(d3.getDate() - 6);


let defaultRegSearch = {
  startDate: d3,
  endDate: d2
};
let defaultFrom = new Date();

let defaultTo = new Date();
defaultTo.setDate(to.getDate() + 6);


class Form extends Component {
  constructor() {
    super();
    this.props = {dates: default_search, defaultFrom: defaultFrom, defaultTo: defaultTo};
    this.state = {
      error: "",
      request_object: default_search,
      indirect: false,
      vertical: false,
      start: defaultRegSearch.startDate,
      end: defaultRegSearch.endDate
    };
    this.handleChange = this.handleChange.bind(this);
    this.changeDirect = this.changeDirect.bind(this);
    this.changeView = this.changeView.bind(this);
  }

  handleChange(date) {
    this.setState({
      startDate: date
    });
  }

  changeDirect() {
    this.setState({indirect: !this.state.indirect,vertical:false});
  }

  changeView() {
      this.setState({vertical: !this.state.vertical,indirect:false});
  }

  componentDidMount() {
    // on TextField
    let request = new Object();
    request.startDate = this.state.start;
    request.endDate = this.state.end;
    request.indirect = this.state.indirect;
    request.vertical = this.state.vertical;
    this.props.dispatch(actions.getTeamWeeklyDetails(request))
  }

  render() {


    const {handleSubmit, pristine, reset, submitting} = this.props;
    const formStyle = {
      paddingBottom: '0px',
      "font-family": '"ProximaNova-Regular", "sans-serif"'

    };
    console.log(this.state.start);
    console.log(this.state.end);


    return (
      <div style={{formStyle}}>

        <form onSubmit={handleSubmit(data => {
          console.log(data);
          if (this.state.start == null || this.state.end == null) {
            console.log('hi');
            this.setState({error: "Check the Dates"});
            return;
          }

          else {
            console.log('hi');
            let request = new Object();
            request.startDate = this.state.start;
            request.endDate = this.state.end;
            request.indirect = this.state.indirect;
            request.vertical = this.state.vertical;
            console.log(request);
            this.props.dispatch(actions.getTeamWeeklyDetails(request));
            this.setState({error: "", request_object: request});
            return;
          }

        })}>

          <div className="col-md-12">
            <div className="col-md-3">
              <img src="/public/images/calendar.png" style={{paddingRight: '10'}}/>

              <DatePicker name="startDate"
                          inputStyle={{color: 'black'}}
                          container="inline"
                          dialogContainerStyle={{color: 'black', padding: 0}}
                          className="rowX"
                          component={DatePicker}
                          autoOk={true}
                          defaultValue={this.state.start}
                          style={{
                            display: 'inline',
                            "font-family": '"ProximaNova-Regular", "sans-serif"',
                            padding: 0,
                            margin: 0,
                            color: 'red'
                          }}
                          mode={'portrait'}
                          textFieldStyle={{width: '80%', "font-family": '"ProximaNova-Regular", "sans-serif"'}}
                          value={this.state.start}
                          onChange={(event, dates)=> {
                            console.log(dates);
                            this.setState({start: dates})


                          }}
                          shouldDisableDate={
                            (day)=> {
                              if (day.getDay() == 6 || day.getDay() == 0)
                                return true;
                            }
                          }

                          formatDate={(date)=> {
                            let end = date;
                            //end.setDate(date.getDate()+7);
                            //this.setState({start: date,end: end})
                            return (date.toString().substring(0, 16));
                          }}
                          floatingLabelText="Start Date"
                          hintText="Start Date"/>

            </div>
            <div className="col-md-3">
              <img src="/public/images/calendarO.png" style={{paddingRight: '10'}}/>
              <DatePicker name="endDate"
                          container="inline"
                          style={{display: 'inline', "font-family": '"ProximaNova-Regular", "sans-serif"'}}
                          component={DatePicker}
                          autoOk={true}
                          onChange={(event, dates)=> {
                            console.log(dates);
                            this.setState({end: dates})
                          }}
                          shouldDisableDate={
                            (day)=> {
                              if (day.getDay() == 6 || day.getDay() == 0)
                                return true;
                            }
                          }


                          value={this.state.end}
                          defaultValue={this.state.end}
                          floatingLabelText="End Date"
                          textFieldStyle={{width: '80%', "font-family": '"ProximaNova-Regular", "sans-serif"'}}
                          mode={'portrait'}

                          formatDate={(date)=> {
                            return (date.toString().substring(0, 16));
                          }}
                          hintText="End Date "/>

            </div>
            <div className="col-md-2">
              <Checkbox
                style={{paddingLeft: '0px', paddingTop: '35px', height: '30px', paddingBottom: 0, width: '40px'}}
                inputStyle={{height: '30px'}}
                iconStyle={{fill: '#5cb85c'}}
                labelStyle={{fontSize: '15px'}}
                checked={this.state.indirect}
                label="Indirect"
                onCheck={()=> {
                  this.changeDirect();
                }}/>
            </div>
              {(this.props.isVertical) ?
                <div className="col-md-2">
                  <Checkbox
                    style={{paddingLeft: '0px', paddingTop: '35px', height: '30px', paddingBottom: 0, width: '40px'}}
                    inputStyle={{height: '30px'}}
                    iconStyle={{fill: '#5cb85c'}}
                    labelStyle={{fontSize: '15px'}}
                    checked={this.state.vertical}
                    label="Vertical"
                    onCheck={()=> {
                       this.changeView();
                    }}/>
                </div> : null}
            <div style={{marginTop: '25px'}} className="col-md-2">
              <Button
                backgroundColor="#008bcf"
                className="btn btn-default btn-lg"
                type="submit"
                disabled={false}><font
                style={{"font-family": '"ProximaNova-Regular", "sans-serif"', color: 'white'}}><b>Search</b></font>
                <img src="/public/images/magnifying-glass.png"
                     style={{'paddingLeft': '6px'}}
                />
              </Button>

              {this.state.error.length == 0 ? <label></label> : <label style={{
                color: 'red',
                paddingLeft: '5px',
                "font-family": '"ProximaNova-Regular", "sans-serif"'
              }}>{this.state.error}</label>}
            </div>
            <div className="col-md-2" style={{display: 'inline', marginTop: '3%'}}>
              <Button
                onClick={()=> {
                  let x = this.state.start;
                  x.setDate(x.getDate() - 7);
                  let y = this.state.end;
                  y.setDate(y.getDate() - 7);
                  this.setState({
                    start: x,
                    end: y
                  });
                  let request = new Object();
                  request.startDate = this.state.start;
                  request.endDate = this.state.end;
                  request.indirect = this.state.indirect;
                  request.vertical = this.state.vertical;
                  console.log(request);
                  this.props.dispatch(actions.getTeamWeeklyDetails(request));
                  this.setState({error: "", request_object: request});

                }
                }>
                <img src="/public/images/back.png"/>
              </Button>
              <Button
                className="btn btn-group-sm"
                onClick={()=> {
                  let x = this.state.start;
                  x.setDate(x.getDate() + 7)
                  let y = this.state.end;
                  y.setDate(y.getDate() + 7);
                  this.setState({
                    start: x,
                    end: y
                  });
                  let request = new Object();
                  request.startDate = this.state.start;
                  request.endDate = this.state.end;
                  request.indirect = this.state.indirect;
                  request.vertical = this.state.vertical;
                  console.log(request);
                  this.props.dispatch(actions.getTeamWeeklyDetails(request));
                  this.setState({error: "", request_object: request});

                }
                }
              ><img src="/public/images/nextD.png"/> </Button>
            </div>


          </div>


        </form>

      </div>
    )
  }
}

export default reduxForm({
  form: 'teamweekly',

})(Form)





/** WEBPACK FOOTER **
 ** ./src/feature/leave/SearchForm2.js
 **/